<template>
  <BaseSelect :value="currentFilter" :options="filterItems" @input="sortFunc"></BaseSelect>
</template>

<script>
export default {
  name: "FilterCampaign",
  props: {
    lclass: String,
    type: String,
    pclass: {
      type: String,
      default: "typo-button14 typo-medium text-light-high"
    }
  },
  data() {
    return {
      currentFilter: ""
    };
  },
  computed: {
    filterItems() {
      if (this.type == "group") {
        return [
          {
            value: "modified",
            text: this.$t("page.sort.modified")
          },
          {
            value: "nameASC",
            text: this.$t("page.sort.name", { order: this.$t("page.sort.az") })
          }
        ];
      }
      if (this.type == "shops") {
        return [
          {
            value: "nameAsc",
            text: this.$t("agency.sort.nameAsc")
          },
          {
            value: "nameDesc",
            text: this.$t("agency.sort.nameDesc")
          },
          {
            value: "plan",
            text: this.$t("agency.sort.plan")
          },
          {
            value: "addedDate",
            text: this.$t("agency.sort.addedDate")
          }
        ];
      }
      return [
        {
          value: "modified",
          text: this.$t("page.sort.modified")
        },
        {
          value: "published",
          text: this.$t("page.sort.published")
        },
        {
          value: "nameASC",
          text: this.$t("page.sort.name", { order: this.$t("page.sort.az") })
        }
      ];
    }
  },
  created() {
    switch (this.type) {
      case "group":
        this.currentFilter = "modified";
        break;
      case "page":
        this.currentFilter = "modified";
        break;
    }
  },
  methods: {
    itemFilterClick(fn) {
      if (this.$refs.moreActionFilter) {
        this.$refs.moreActionFilter.toggleDropdown();
      }
      if (fn) fn();
    },
    sortFunc(sort) {
      this.currentFilter = sort;
      this.$emit("onClickFilter", sort);
    }
  }
};
</script>

<style lang="scss" scoped></style>
